import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "orderBy",
})
export class OrderBy implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field] == b[field]) return 0;
      if (a[field] == "All" || a[field] == "NONE") return -1;
      if (b[field] == "All" || b[field] == "NONE") return 1;

      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
